import { render } from "./SchedaContenuto.vue?vue&type=template&id=d71db662"
import script from "./SchedaContenuto.vue?vue&type=script&lang=js"
export * from "./SchedaContenuto.vue?vue&type=script&lang=js"

import "./SchedaContenuto.vue?vue&type=style&index=0&id=d71db662&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__